var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWheelIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.27 19.786H5.51v-.762h8.76v.762zm-1.604-1.363H7.334v-1.105a8.689 8.689 0 005.332 0v1.105zm-1.133-17.24a7.999 7.999 0 11-3.062 0l.38.764a7.237 7.237 0 102.3 0l.38-.764h.002zm-2.855 9.784c.28.2.602.333.941.39v4.205a6.431 6.431 0 01-3.912-1.624l2.97-2.971zm5.614 2.97a6.43 6.43 0 01-3.911 1.625v-4.205c.339-.057.66-.19.94-.39l2.971 2.97zM7.749 9.489c.057.34.19.66.39.94L5.168 13.4a6.453 6.453 0 01-1.623-3.91h4.204zm8.705 0a6.453 6.453 0 01-1.623 3.911l-2.97-2.97c.199-.28.332-.602.389-.94h4.204zM10 7.584a1.524 1.524 0 110 3.047 1.524 1.524 0 010-3.047zm-1.861.201c-.2.28-.333.602-.39.942H3.543a6.477 6.477 0 011.62-3.92L8.14 7.786zm6.698-2.977a6.476 6.476 0 011.62 3.918H12.25a2.27 2.27 0 00-.39-.94l2.977-2.978zM9.619 3.484v3.372c-.339.058-.661.19-.941.39L5.696 4.265A6.424 6.424 0 019.211 2.67l.408.813zm1.17-.815a6.426 6.426 0 013.515 1.596L11.32 7.246c-.28-.2-.601-.333-.94-.39V3.482l.407-.814zM10 3.076L8.712.5h2.576L10 3.076z",
    fill: "#9A9CAC",
    stroke: "#9A9CAC",
    strokeWidth: 0.3
  })));
}

export default SvgWheelIcon;